import React from 'react'
import './Footer.css'

import footer_logo from '../Assets/logo_big.png'
import instagram_icon from '../Assets/instagram_icon.png'
import pintrest_icon from '../Assets/pintester_icon.png'
import whatsapp_icon from '../Assets/whatsapp_icon.png'

const Footer = () => {
  return (
    <div className='footer'>
      <div className="footer-logo">
        <img src={footer_logo} alt="" />
        <p>FREECYCLE</p>
      </div>
      <ul className="footer-links">
        <p>The goal of this project is to develop an online platform that facilitates the exchange, resale, donation, and rental of used goods, specifically for students living in college hostels. The platform will connect graduating students who wish to pass on their belongings (e.g., bicycles, furniture, electronics) with incoming students. Founded by Aditya, Sharanya and Adarsh under the guidance of Professor Ganga Prasath & Lakshminath </p>
      </ul>
      <div className="footer-social-icons">
        <div className="footer-icons-container">
            <img src={instagram_icon} alt="" />
        </div>
        <div className="footer-icons-container">
            <img src={pintrest_icon} alt="" />
        </div>
        <div className="footer-icons-container">
            <img src={whatsapp_icon} alt="" />
        </div>
      </div>
      <div className="footer-copyright">
        <hr />
        <p>Copyright @ 2024 - All Right Reserved.</p>
      </div>
    </div>
  )
}

export default Footer
